import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const fetchContactById = async (id: number) => {
  const url = `${urls.GET_CONTACT_BY_ID}/${id}/new`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchTagsByContactById = async (id: number) => {
  const url = `${urls.GET_TAG_BY_CONTACT_ID}/${id}/new`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteTagByContactById = async (
  contactId: number,
  tagId: number
) => {
  const url = `${urls.DELETE_TAG_BY_CONTACT_ID}/${contactId}/tagId/${tagId}`;
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const unsubscribeContactById = async (contactId: number) => {
  const url = `${urls.UNSUBSCRIBE_CONTACT_BY_ID}/${contactId}`;
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchContactGroupsCountById = async (contactId: number) => {
  const url = `${urls.GET_GROUPS_COUNT_BY_CONTACT_ID}/${contactId}/new`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchContactGroupsById = async (
  contactId: number,
  page: number,
  rowsPerPage: number
) => {
  const url = `${urls.GET_GROUPS_BY_CONTACT_ID}/${contactId}/page/${page}/limit/${rowsPerPage}/new`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateContactProfile = async (contactProfile: any) => {
  try {
    const callParams = await getCallParams("POST", contactProfile);
    const response = await makeCall(urls.UPDATE_CONTACT_PROFILE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
